/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import { GetInitiativeLibrary } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import SkeletonLoder from "../../common/skeletonLoder";
import { NoData } from "../styles";
import { InitiativesWrap, InitiativeCard } from "../../HealthDataManagement/styles";
import { RecognitionEyeIconNew, RecognitionLaunchIcon, StarIconSmall, AdminCategoriesNew } from "../../../utils/icons";
import DetailPopup from "../../HealthDataManagement/initiativesInfo";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Layout, Container } from "../../MainEvents/CompanyLiveEvents/styles";
import { SliderContainer, ReservedButton } from "../../MainEvents/styles";
import { CompanyCard } from "../../MainEvents/CompanyLiveEvents/styles";
import LazyImage from "../../common/LazyImage/LazyImage";
import { NewBackArrowIconEventPage, NewNextArrowIconEventPage } from "../../../utils/icons";
import { Heading } from "../../WellnessAdmin/style";


const NextArrow = ({ currentSlide, slideCount, onClick }) => {
  if (currentSlide === slideCount - 1) return null;
  return <div className="left-arrow slick-next" onClick={onClick} style={{ display: "block" }} />;
};
NextArrow.propTypes = { currentSlide: PropTypes.number.isRequired, slideCount: PropTypes.number.isRequired, onClick: PropTypes.func };

const PrevArrow = ({ currentSlide, onClick }) => {
  if (currentSlide === 0) return null;
  return <div className="left-arrow slick-prev" onClick={onClick} style={{ display: "block" }} />;
};
PrevArrow.propTypes = { currentSlide: PropTypes.number.isRequired, onClick: PropTypes.func };

class libraryInitiative extends Component {
  sliderRef = null;

  constructor(props) {
    super(props);
    this.state = {
      companyId: this.props.companyInfo.id,
      loading: false,
      showDetailPopup: false,
      detailInitiative: null,
      libraryInitiatives: [],
      currentSlide: 0,
    };
  }

  componentDidMount() {
    this.getLibraryInitiatives();
  }

  hideShowPopup = () => {
    this.setState({ showDetailPopup: false, detailInitiative: null });
  };

  getLibraryInitiatives = async () => {
    this.setState({ loading: true });
    try {
      const res = await fetchApi(GetInitiativeLibrary + "/" + this.state.companyId, "GET");
      if (res.status === "success") {
        this.setState({ libraryInitiatives: res?.data, loading: false });
      } else {
        toast.error(res.error);
        this.setState({ loading: false });
      }
    } catch (error) {
      window.console.error(error);
      this.setState({ loading: false });
    }
  };

  redirectToCompanyInitiative = () => {
    this.props.history.push({
      pathname: '/company/initiative-library',
      state: { companyId: this.state.companyId },
    });
  };

  render() {
    const { libraryInitiatives, loading, showDetailPopup, detailInitiative, currentSlide } = this.state;

    if (loading) {
      return <SkeletonLoder width="1248px" height="500px" />;
    }

    if (!libraryInitiatives?.length) {
      return <NoData>No Data Found!</NoData>;
    }

    const featuredItems = libraryInitiatives.slice(0, 5);
    const gridItems = libraryInitiatives.slice(5);

    const sliderSettings = {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      draggable: true,
      adaptiveHeight: true,
      nextArrow: <NextArrow currentSlide={currentSlide} slideCount={featuredItems.length} />,
      prevArrow: <PrevArrow currentSlide={currentSlide} />,
      beforeChange: (_, next) => this.setState({ currentSlide: next }),
    };

    return (
      <>
        <Layout
          style={{ background: "#fff", border: "0.75px solid #DCDCDC" }}
          margin="20px 0 5px 0"
          padding="20px 20px 30px 20px"
          background="#fff"
        >
          <div className="headingMain">
            <div style={{ gap: "12px" }} className="heading">
              <div style={{ display: "flex", alignItems: "center" }}>
                {StarIconSmall("#184A61")}
              </div>
              {"Featured Initiatives"}
            </div>
            {featuredItems.length > 1 && (
              <div className="arrows">
                <div
                  className="iconBackground"
                  onClick={() => this.sliderRef?.slickPrev()}
                  style={{ opacity: currentSlide === 0 ? 0 : 1, cursor: currentSlide === 0 ? "not-allowed" : "pointer" }}
                >
                  {NewBackArrowIconEventPage()}
                </div>
                <div className="text">{currentSlide + 1} / {featuredItems.length}</div>
                <div
                  className="iconBackground"
                  onClick={() => currentSlide < featuredItems.length - 1 && this.sliderRef?.slickNext()}
                  style={{ opacity: currentSlide === featuredItems.length - 1 ? 0 : 1, cursor: currentSlide === featuredItems.length - 1 ? "not-allowed" : "pointer" }}
                >
                  {NewNextArrowIconEventPage()}
                </div>
              </div>
            )}
          </div>
          <Container>
            <SliderContainer display="flex" content="center" shadow="0px 8px 25px 0px #0D427040">
              <Slider {...sliderSettings} ref={(s) => { this.sliderRef = s; }}>
                {featuredItems.map((initiative, index) => (
                  <div className="card featCard" key={index}>
                    <CompanyCard
                      className="featChallanges"
                      detailsCardPadding="0 0 10px 20px"
                      width="1248px"
                    >
                      <LazyImage
                        div="imageCard featImg"
                        style={{ borderRadius: "8px 0 0 8px", background: initiative?.color, display: "flex", alignItems: "center", justifyContent: "center" }}
                        src={`${ImageUrl}/${initiative?.initiative_white_icon}`}
                        alt="initiative"
                      />
                      <div
                        className="detailsCard"
                        style={{ border: "0.75px solid #DCDCDC", padding: "0 20px 20px 20px", borderRadius: "0 8px 8px 0", borderLeft: "0" }}
                      >
                        <div className="title">{initiative?.initiative_name}</div>
                        <div className="description" style={{ paddingTop: "20px", color: "#005C87", fontFamily: "Lato", fontSize: "16px" }}>
                          {initiative?.description || ""}
                        </div>
                        <div className="moving-btn" style={{ marginTop: "auto", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "16px" }}>
                          <ReservedButton
                            active
                            width="268px"
                            height="40px"
                            onClick={() =>
                              initiative?.re_launch_status
                                ? this.redirectToCompanyInitiative(initiative)
                                : this.setState({ showDetailPopup: true, detailInitiative: initiative })
                            }
                          >
                            <div style={{ marginRight: "8px" }}>
                              {initiative?.re_launch_status ? "Launch Initiative" : "View Details"}
                            </div>
                          </ReservedButton>
                        </div>
                      </div>
                    </CompanyCard>
                  </div>
                ))}
              </Slider>
            </SliderContainer>
          </Container>
        </Layout>

        {gridItems.length > 0 && (
          <>
            <Heading>
              <div className="icon" style={{ marginRight: "4px" }}>{AdminCategoriesNew("#184A61")}Health Initiatives categories</div>
            </Heading>
            <InitiativesWrap>
              <div className="details">
                {gridItems.map((initiative) => (
                  <div className="initiative-card" key={initiative.id}>
                    <InitiativeCard background={initiative?.color}>
                      <div className="icon">
                        <img src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt="initiative" />
                      </div>
                      <div className="initiative-title">{initiative.initiative_name}</div>
                      <div
                        className="end-container"
                        onClick={() =>
                          initiative?.re_launch_status
                            ? this.redirectToCompanyInitiative(initiative)
                            : this.setState({ showDetailPopup: true, detailInitiative: initiative })
                        }
                      >
                        {initiative?.re_launch_status ? RecognitionLaunchIcon() : RecognitionEyeIconNew()}
                      </div>
                    </InitiativeCard>
                  </div>
                ))}
              </div>
            </InitiativesWrap>
          </>
        )}

        {showDetailPopup && (
          <DetailPopup
            showModal={showDetailPopup}
            detailInitiative={detailInitiative}
            onClose={this.hideShowPopup}
            companyId={this.props.companyInfo.id}
          />
        )}
      </>
    );
  }
}

libraryInitiative.propTypes = {
  history: PropTypes.object,
  companyInfo: PropTypes.any,
  selectedYearInfo: PropTypes.number,
};

export default connect(null, null)(libraryInitiative);
